/**
 * Wat de leerling aan de server vraagt: één functie per /student-endpoint.
 *
 * Let op de naam `leerlingLesId`: in de paden heet hij `session_id`, maar
 * het is niet de les zelf. Het is de les van deze ene leerling
 * (student_sessions.id), zoals /student/active-session hem teruggeeft.
 */
import { verzoek } from './client';

const post = (pad, json) => verzoek(pad, { method: 'POST', json });

export const leerlingApi = {
  haalActieveLes: () => verzoek('/student/active-session'),
  haalGelezenTeksten: () => verzoek('/student/completed-sessions'),
  haalGelezenTekst: (leerlingLesId) => verzoek(`/student/completed-session/${leerlingLesId}`),
  beginMetLezen: (leerlingLesId) => verzoek(`/student/start-reading/${leerlingLesId}`, { method: 'POST' }),
  /** In een groepsles (stap 23): klaar met lezen; er is geen toets. */
  rondLezenAf: (leerlingLesId) => verzoek(`/student/finish-reading/${leerlingLesId}`, { method: 'POST' }),
  haalAlineas: (leerlingLesId) => verzoek(`/student/paragraphs/${leerlingLesId}`),
  /** Het plaatje bij de les, als blob; het pad komt uit haalActieveLes(). */
  haalIllustratie: (pad) => verzoek(pad, { als: 'blob' }),

  // de hulpmiddelen bij het lezen; de les gaat mee, want Vereenvoudig en
  // Uitleg volgen het niveau waarop de leerling in die les leest
  vereenvoudig: (alineaId, huidigNiveau, leerlingLesId) =>
    post('/student/simplify', { paragraph_id: alineaId, current_niveau: huidigNiveau, session_id: leerlingLesId }),
  // huidigNiveau: na Vereenvoudig het niveau van wat er nu staat, zodat de server precies die tekst neemt (stap 25c)
  vertaal: (alineaId, leerlingLesId, huidigNiveau) =>
    post('/student/translate', { paragraph_id: alineaId, session_id: leerlingLesId, current_niveau: huidigNiveau }),
  legUit: (alineaId, selectie, leerlingLesId, huidigNiveau) =>
    post('/student/explain', { paragraph_id: alineaId, selected_text: selectie, session_id: leerlingLesId,
      current_niveau: huidigNiveau }),
  /** De tekst als audio (mp3), als blob. */
  // de alinea en de tekst zoals de leerling hem ziet; de server bewaart de opname alleen als die bij de alinea hoort
  leesVoor: (alineaId, tekst, leerlingLesId) => verzoek('/student/read-aloud', { method: 'POST',
    json: { paragraph_id: alineaId, text: tekst, session_id: leerlingLesId }, als: 'blob' }),
  /** De vertaling van de alinea in de moedertaal (na vertaal), als audio; de tekst haalt de server zelf. */
  leesVertalingVoor: (alineaId, leerlingLesId, huidigNiveau) =>
    verzoek('/student/read-aloud', { method: 'POST', json: { paragraph_id: alineaId, session_id: leerlingLesId, vertaling: true,
      current_niveau: huidigNiveau }, als: 'blob' }),

  // de toets
  haalMeerkeuzevragen: (leerlingLesId) => verzoek(`/student/quiz/${leerlingLesId}/mc`),
  verstuurMeerkeuze: (leerlingLesId, antwoorden) => post(`/student/quiz/${leerlingLesId}/mc/submit`, antwoorden),
  haalOpenVragen: (leerlingLesId) => verzoek(`/student/quiz/${leerlingLesId}/open`),
  verstuurOpenVragen: (leerlingLesId, antwoorden) => post(`/student/quiz/${leerlingLesId}/open/submit`, antwoorden),
};
